module.exports = __webpack_public_path__ + "img/proList2_23.8c0e5057.jpg";